<template>
  <div class="main-container">
    <div class="container">
      <h2 class="config-headline">
        <img
          src="../assets/images/icon/icon_location_marker.svg"
          alt=""
          class="icon-config-headline"
        />
        飛行エリア未設定
      </h2>
      <div class="config-content">
        <p>
          <span class="text-red">飛行エリアが設定されていません。</span><br />
          「飛行エリア設定」画面より、飛行エリアの設定を行ってください。
        </p>
        <button class="button-primary" @click="toFlightAreasPage">飛行エリア設定へ</button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import { onMounted, onUnmounted } from 'vue'

//飛行エリア設定画面へ遷移
const router = useRouter()
const toFlightAreasPage = () => {
  router.push('/flight-areas')
}

onMounted(() => {
  document.body.classList.add('confirm')
})
onUnmounted(() => {
  document.body.classList.remove('confirm')
})
</script>
